// extracted by mini-css-extract-plugin
export default {"items":"Dl3Yf"};